import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, output, signal } from "@angular/core";
import { MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";

import { PageInfo } from "../../../../../apis/networkdashboard/graphql/graphql";
import { PaginatorIntlService } from "./intl.service";

// @todo rename to PaginationExpanded or something
@Component({
  selector: "pagination-numbered",
  templateUrl: "numbered.html",
  styleUrls: ["../../pagination.scss"],
  imports: [MatPaginatorModule, AngularSvgIconModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntlService,
    },
  ],
})
export class PaginationNumbered {
  public pageInfo = input.required<PageInfo>();
  public pageChange = output<number>();
  public pageSizeChanged = output<number>();
  protected itemsPerPage = signal(Number(localStorage.getItem("paginationSize") ?? 10));
  protected totalItems = computed(() => this.pageInfo().totalItems);

  private pageToCursor(v: number) {
    return Math.floor(v * this.itemsPerPage());
  }

  protected handlePageEvent($event: PageEvent) {
    if ($event.pageSize !== this.itemsPerPage()) {
      this.storePreference($event.pageSize);
    } else {
      this.goToPage($event.pageIndex);
    }
  }

  private goToPage(v: number) {
    this.pageChange.emit(this.pageToCursor(v));
  }

  private storePreference(v: number) {
    localStorage.setItem("paginationSize", v.toString());

    // update local state so when changing the pagesize to something else and setting it back again, the paginator will update.
    this.itemsPerPage.set(v);
    this.pageSizeChanged.emit(v);
  }
}
